module.exports = __webpack_public_path__ + "media/images/gn_icon02-2256f39267c5e9bb6eb19a223ebf2fb0.png";